import { produce } from "immer";
import { WeekdayNumbers } from "luxon";
import { AnyAction } from "redux";

import { SET_AGENDA_RANGE } from "../constants";
import { AgendaRangeType } from "../enums";
import { AgendaRangeMinute } from "../types";

export interface AgendaRange {
  type: AgendaRangeType;
  dayFrom: WeekdayNumbers;
  dayTo: WeekdayNumbers;
  timeFrom: HourAndMinute;
  timeTo: HourAndMinute;
  range: AgendaRangeMinute;
}

export interface HourAndMinute {
  hour: number;
  minute: number;
}

const initState: AgendaRange = {
  type: AgendaRangeType.WEEK,
  dayFrom: 1,
  dayTo: 7,
  timeFrom: { hour: 8, minute: 0 },
  timeTo: { hour: 20, minute: 0 },
  range: 60,
};

const agendaReducer = produce((draft = initState, action: AnyAction) => {
  let agendaRange: AgendaRange = draft;
  switch (action.type) {
    case SET_AGENDA_RANGE:
      if (action.payload.type !== AgendaRangeType.CUSTOM) {
        agendaRange = {
          type: action.payload.type,
          dayFrom: 1,
          dayTo: 7,
          timeFrom: { hour: 8, minute: 0 },
          timeTo: { hour: 20, minute: 0 },
          range: 60,
        };
      } else {
        agendaRange = action.payload;
      }

      return agendaRange;
    default:
      return draft;
  }
});

export default agendaReducer;
